import React from "react";
import styled from "styled-components";
import uvegLogo from "../NavBar/LOGO 2.png"; // tu ruta exacta

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 40px;
  margin: 40px auto;
  max-width: 1400px;
`;

const Card = styled.div`
  background: #0A5364;            /* ← color solicitado */
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  border-radius: 0;
  width: 380px;
  padding: 40px 30px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 420px;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25);
  }
`;

/* Contorno negro con múltiples drop-shadows (simula stroke) */
const Logo = styled.img`
  width: 220px;
  height: auto;
  margin: 0 auto 30px;
  display: block;

  /* “Halo” negro alrededor para que resalte sobre el fondo */
  filter:
    drop-shadow(0 0 0 #000)
    drop-shadow(0 1px 0 #000)
    drop-shadow(1px 0 0 #000)
    drop-shadow(-1px 0 0 #000)
    drop-shadow(0 -1px 0 #000)
    drop-shadow(0 0 4px rgba(0,0,0,0.6));
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 800;
  color: #ffffff;                  /* texto blanco */
  margin-bottom: 20px;
  font-family: 'Merriweather', serif;
  letter-spacing: 0.2px;
`;

const Description = styled.p`
  font-size: 1.15rem;
  color: #ffffff;                  /* texto blanco */
  line-height: 1.6;
  text-align: center;
  font-family: 'Merriweather', serif;
  opacity: 0.95;
`;

const LogoCards = () => {
  const logos = [
    {
      img: uvegLogo,
      title: "Universidad Virtual del Estado de Guanajuato",
      description: "Líder en educación virtual en México.",
    },
    {
      img: "https://raw.githubusercontent.com/AppsDevsLeon/Logos/refs/heads/main/logo1.png",
      title: "Coach Blockchain",
      description: "Plataforma especializada en formación y proyectos blockchain de alto impacto.",
    },
  ];

  return (
    <CardContainer>
      {logos.map((logo, index) => (
        <Card key={index}>
          <Logo
            src={logo.img}
            alt={`${logo.title} logo`}
            loading="lazy"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <Title>{logo.title}</Title>
          <Description>{logo.description}</Description>
        </Card>
      ))}
    </CardContainer>
  );
};

export default LogoCards;
